<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="group_4">
                <CarCard :carDetails="carDetail"></CarCard>
                <div class="section_3">
                    <div class="justify-between group_9">
                        <div class="flex-row">
                            <span class="text_12">姓名</span>
                            <input type="text" class="text_13" v-model="userName" placeholder="请输入您的姓名" />
                        </div>
                        <span class="text_14">先生/女士</span>
                    </div>
                    <div class="flex-row group_11">
                        <span class="text_15">手机号</span>
                        <input class="text_16" v-model="userPhone" type="number" placeholder="请输入手机号" />
                    </div>
                </div>
                <div class="flex-col section_4">
                    <van-collapse v-model="activeNames">
                        <van-collapse-item title="参数配置" name="1">
                            <van-cell-group>
                                <van-cell v-for="item in paramConfig" :title="item.label" :key="item.label"
                                    :value="item.value"></van-cell>
                            </van-cell-group>
                        </van-collapse-item>
                        <van-collapse-item title="车身尺寸" name="2">
                            <van-cell-group>
                                <van-cell v-for="item in carSize" :title="item.label" :key="item.label"
                                    :value="item.value"></van-cell>
                            </van-cell-group>
                        </van-collapse-item>
                    </van-collapse>
                </div>
                <div class="flex-col items-center text-wrapper_2" v-if="carDetail.cartypeDetailImg">
                    <template v-for="src in carDetail.cartypeDetailImg.split(',')">
                        <img :src="mixin_imgs[getOSSImg(src)]" alt="" />
                    </template>
                </div>
            </div>
            <div class="flex-col footer">
                <div class="flex-row group_16">
                    <img @click="isAgree = !isAgree"
                        :src="isAgree ? 'https://imgpub1.shouqiev.com/gofunplatform/files/20220801/cByvEyzDVF.png' : 'https://imgpub1.shouqiev.com/gofunplatform/files/20220816/wwPATTpQyZ.png'"
                        class="image_5" />
                    <div class="group_17">
                        <span class="text_28" @click="isAgree = !isAgree">阅读并同意</span>
                        <template v-for="item in agreements">
                            <span
                                @click="jsBridge.appOpenUrl(`https://h5.shouqiev.com/app/pdf/web/viewer.html?file=${item.templateUrl}&title=${item.templateName}`)"
                                class="text_29">{{
                                        item.templateName
                                }}</span>
                        </template>
                    </div>
                </div>
                <div class="flex-col items-center button" @click="makeOrder">
                    <span class="text_30">去预定</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCarDetail, getTemplatesByBusinessIdLists } from "../api";
import CarCard from "../_components/CarCard.vue";
import { Cell, CellGroup } from "vant";
import { Toast, Collapse, CollapseItem } from "vant";
import jsBridge from "@/libs/jsBridge";

import "vant/lib/cell/style";
import "vant/lib/cell-group/style";
import "vant/lib/collapse/style";
import "vant/lib/collapse-item/style";
import { getImgMixin } from "../getImg_mixin";

import { createOrder } from "../api";
export default {
    components: { CarCard, Cell, CellGroup, Toast, Collapse, CollapseItem },
    data() {
        return {
            jsBridge,
            isAgree: false,
            activeNames: ["1"],
            showAll: false,
            carDetail: {},
            userName: "",
            info: {},
            userPhone: "",
            paramConfig_key: {
                // carTypeLevel
                energy: "能源类型",
                brand: "品牌",
                series: "车系",
                carTypeModel: "车型分类",
                name: "车型名称",
                transmissionType: "变速箱",
                facadeColor: "外观颜色",
                interiorColor: "内饰颜色",
                nedcConsume: "nedc综合油耗(L/100km)",
                carStore: "车辆库存",
                officialGuidePrice: "官方指导价",
                presellPrice: "车辆预订价",
                // 能源类型,
                emissionStand: "排放标准",
                engine: "发动机",
                carTypePower: "排量",
                torqueMaxueMax: "最大扭矩(N·m)",
                maxPower: "最大功率(k·w)",
                maxSpeed: "最高车速(km/h)",
                // 电
                horsepower: "电动机总马力(ps)",
                torqueMaxueMax: "电动机总扭矩(N·m)",
                beforeMotormaxPower: "前电动机最大功率(kw)",
                totalMotorPower: "电动机总功率(kw)",
                batteryType: "电池类型",
                frontmotorTorqueMax: "前电动机最大扭矩(N·m)",
                motor: "电动机",
                quickChargeTime: "电池充电时间(h)快充",
                slowChargeTime: "电池充电时间(h)慢充",
                batteriesBrand: "电芯品牌",
                batteryCapacity: "混动电量",
                tankCapacity: "电池电量(kWh)/油箱容积(L)",
                // 能源类型,
                // 排放标准,
                // NEDC纯电续航(km),
                carTypeMileage: "NEDC纯电续航(km)",
            },
            paramConfig: [],
            carSize: [],
            carDetailResult: {},
            carSize_key: {
                lengthWidthHeight: "长宽高(mm)",
                curbWeight: "整备质量(kg)",
                wheelbase: "轴距(mm)",
                beforeWheelbase: "前轮距(mm)",
                afterWheelbase: "后轮距(mm)",
                baggageCompartmentCapacity: "行李舱容积(L)",
                carTypeBody: "车身结构",
                tankCapacity: "油箱容积(L)",
            },
            energyList: {
                1: "电车",
                2: "油车",
                3: "混动",
            },
            agreements: [],
        };
    },
    mixins: [getImgMixin],
    created() {
        this.init();
        this.info = JSON.parse(jsBridge.getReportInfo());
        this.userPhone = this.info.sim;
        getTemplatesByBusinessIdLists({
            companyId: "1538",
            templateTypeList: [1041],
        }).then((res) => {
            this.agreements = res.result;
        });
    },
    methods: {
        init() {
            getCarDetail({ id: this.$route.params.id }).then((res) => {
                this.carDetailResult = res.result;
                this.carDetail = { ...res.result, markIcon: true };
                this.paramConfig = [];
                Object.keys(this.paramConfig_key).forEach((key) => {
                    if (this.carDetail[key]) {
                        this.paramConfig.push({
                            label: this.paramConfig_key[key],
                            value:
                                key == "energy"
                                    ? this.energyList[this.carDetail[key]]
                                    : this.carDetail[key],
                        });
                    }
                });
                Object.keys(this.carSize_key).forEach((key) => {
                    if (this.carDetail[key]) {
                        this.carSize.push({
                            label: this.carSize_key[key],
                            value: this.carDetail[key],
                        });
                    }
                });
                // carSize
            });
        },
        makeOrder() {
            if (!this.userName) {
                Toast.fail("请填写姓名");
                return false;
            }
            if (this.userPhone.length != 11) {
                Toast.fail("请填写正确的手机号");
                return false;
            }
            if (!this.isAgree) {
                Toast.fail("请阅读并同意协议");
                return false;
            }
            let cityCode = ''
            this.info.content && (cityCode = this.info.content[0].selectedCityCode)
            createOrder({
                carTypeId: this.carDetail.carTypeId,
                userName: this.userName,
                phone: this.userPhone,
                cartypeName: this.carDetail.name,
                carSaleId: this.carDetail.carSaleId,
                userId: "",
                cityCode, // 取用户选择城市
                companyId: "1538", // 一期商户写死
                templateTypeList: this.agreements.map(item => item.templateType),
            }).then((res) => {
                if (res.code != 200) return false;
                this.$router.push({
                    path: "/salePassat/pay",
                    query: {
                        orderId: res.result.orderId,
                        from: "salePassat",
                        apiPath: "", // todo
                        // returnRouter:this.$route.fullPath,
                        returnRouter: `/salePassat/paySucc`,
                        payAmount: this.carDetail.presellPrice,
                    },
                }); //传orderId
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 16px;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        .group_4 {
            padding: 0 0.21rem;
            padding-bottom: 225px;

            .section_3 {
                margin-top: 0.21rem;
                padding: 0 0.32rem;
                background-color: #ffffff;
                border-radius: 0.21rem;

                .group_9 {
                    height: 105px;
                    line-height: 105px;
                    border-bottom: solid 1px #e0e0e0;

                    .text_14 {
                        color: #333333;
                        font-size: 0.37rem;
                        font-family: "PingFang SC";
                    }

                    .text_12 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: "PingFang SC";
                    }

                    .text_13 {
                        margin-left: 1.01rem;
                        color: #999999;
                        font-size: 0.37rem;
                        font-family: "PingFang SC";
                        line-height: 0.53rem;
                    }
                }

                .group_11 {

                    height: 105px;
                    line-height: 105px;

                    .text_15 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: "PingFang SC";
                    }

                    .text_16 {
                        margin-left: 0.64rem;
                        color: #333333;
                        font-size: 0.37rem;
                        font-family: "PingFang SC";
                        font-weight: 500;
                        align-items: center;
                    }
                }
            }

            .section_4 {
                margin-top: 0.21rem;
                padding: 0.43rem 0.32rem 0.43rem 0.33rem;
                padding: 0.43rem 0;
                background-color: #ffffff;
                border-radius: 0.21rem;
                padding: 0;
                // overflow: hidden;

                .text_17 {
                    margin-left: 0.093rem;
                    align-self: flex-start;
                    color: #141e25;
                    font-size: 0.43rem;
                    font-family: "PingFang SC";
                    font-weight: 500;
                    line-height: 0.59rem;
                    margin-bottom: 32px;
                }
            }

            .text-wrapper_2 {
                margin-top: 0.21rem;
                background-color: #ffffff;
                border-radius: 0.21rem;

                .text_27 {
                    color: #141e25;
                    font-size: 0.64rem;
                    font-family: "PingFang SC";
                    line-height: 0.88rem;
                }
            }
        }

        .footer {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 0 0.43rem 0.49rem;
            background-color: #ffffff;
            border-top: solid 0.013rem #e0e0e0;

            .group_16 {
                padding: 0.31rem 0 0.43rem;

                .group_17 {
                    margin-left: 0.21rem;
                    height: 32px;
                    line-height: 32px;

                    .text_28 {
                        color: #778690b3;
                        font-size: 0.32rem;
                        font-family: "FZLanTingHeiS-R-GB";
                        line-height: 0.37rem;
                    }

                    .text_29 {
                        color: #6417ffb3;
                        font-size: 0.32rem;
                        font-family: "FZLanTingHeiS-R-GB";
                        line-height: 0.37rem;
                    }
                }
            }

            .button {
                margin: 0 0.11rem;
                padding: 0.35rem 0 0.32rem;
                background-color: #02d644;
                border-radius: 0.59rem;

                .text_30 {
                    color: #ffffff;
                    font-size: 0.43rem;
                    font-family: "FZLanTingHeiS-DB-GB";
                    line-height: 0.51rem;
                }
            }
        }

        .image_5 {
            width: 0.43rem;
            height: 0.43rem;
        }
    }

    /deep/ .van-collapse-item__title--expanded::after {
        border: none;
    }

    /deep/ .van-collapse-item__content {
        padding: 0;

        .van-cell__title {
            color: #666;
        }

        .van-cell__value {
            color: #333;
        }
    }

    /deep/ .van-collapse-item__title .van-cell__title {
        font-weight: bold;
    }
}

/deep/ .van-cell__title {
    flex: auto;
}

/deep/ .van-cell__value {
    flex: 3;
}

/deep/ .van-cell::after {
    border: none;
}

/deep/ [class*="van-hairline"]::after {
    border: none;
}

// /deep/ .van-collapse-item--border::after {
//     border: none;
// }

/deep/ .van-collapse-item__title::after {
    border: none;
}

::placeholder {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #999;
    font-weight: 100;
}

/deep/ .van-collapse-item {
    // border:solid red 1px;
    // height: 108px;
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// carDetail.vue?8fb6efc8